<template>
  <v-dialog :value="true" persistent scrollable max-width="1000" :fullscreen="$store.getters.mobile" content-class="busqueda-med">
    <v-card>
      <div class="busqueda-med__encabezado">
        <v-icon color="white" class="mr-2">mdi-text-box-search-outline</v-icon>
        <span class="busqueda-med__titulo">Buscar productos</span>
        <v-spacer></v-spacer>
        <v-btn icon color="white" @click="$emit('close')" title="Cerrar"><v-icon>mdi-close</v-icon></v-btn>
      </div>

      <div class="busqueda-med__filtros">
        <ng-text-keyboard v-model="texto" :filled="false" dense hide-details clearable autofocus background-color="grey lighten-5"
          placeholder="Nombre, principio activo, marca, proveedor o EAN" append-icon="mdi-magnify" :nudgetTop="0" :readOnly="false"
          :inputmode="$store.getters.mobile ? 'text' : 'none'" @click:clear="texto = ''" />
        <div class="busqueda-med__fila">
          <v-btn x-small text color="primary" @click="masFiltros = !masFiltros">
            <v-icon x-small left>{{ masFiltros ? "mdi-chevron-up" : "mdi-tune-variant" }}</v-icon>{{ masFiltros ? "Menos filtros" : "Filtrar por campo" }}
          </v-btn>
          <v-btn x-small text color="grey darken-1" v-if="hayFiltros" @click="limpiar"><v-icon x-small left>mdi-close</v-icon>Limpiar</v-btn>
          <v-spacer></v-spacer>
          <span class="caption grey--text text--darken-1">{{ cargando ? "Buscando…" : total + (total === 1 ? " resultado" : " resultados") }}</span>
        </div>
        <v-expand-transition>
          <div v-show="masFiltros" class="busqueda-med__campos">
            <ng-text label="EAN" v-model="filtros.ean" hide-details dense />
            <ng-text label="Nombre" v-model="filtros.name" hide-details dense />
            <ng-text label="Proveedor" v-model="filtros.provider_name" hide-details dense />
          </div>
        </v-expand-transition>
        <div v-if="ingredienteActivo" class="busqueda-med__generico">
          <v-icon small color="teal darken-2" class="mr-1">mdi-swap-horizontal</v-icon>
          Todo lo que tiene <strong class="mx-1">{{ ingredienteActivo }}</strong>
          <v-btn x-small text color="teal darken-2" @click="limpiar">Ver todos</v-btn>
        </div>
      </div>

      <v-divider></v-divider>
      <v-card-text class="pa-0 busqueda-med__lista">
        <div v-if="!cargando && total === 0" class="text-center grey--text py-10">
          <v-icon large color="grey lighten-1">mdi-magnify-close</v-icon>
          <div class="mt-2">No encontramos medicamentos</div>
          <div class="caption">Prueba con el principio activo o con menos palabras.</div>
        </div>
        <div v-for="m in visibles" :key="m.id" class="med" :class="{ 'med--agotado': agotado(m) }">
          <div class="med__datos">
            <div class="med__nombre">{{ m.info_medication.name || m.name }}</div>
            <div class="med__detalle">
              <a v-if="m.info_medication.active_ingredient" class="med__principio" title="Ver todo lo que tiene este principio activo"
                @click.prevent="verGenericos(m)"><v-icon x-small color="teal darken-2">mdi-flask-outline</v-icon>{{ m.info_medication.active_ingredient }}</a>
              <span v-if="m.info_medication.concentration"> · {{ m.info_medication.concentration }}</span>
              <span v-if="m.info_medication.pharmaceutical_form"> · {{ m.info_medication.pharmaceutical_form }}</span>
            </div>
            <div class="med__detalle med__detalle--tenue">
              <span v-if="m.info_medication.provider_name">{{ m.info_medication.provider_name }}</span>
              <span v-if="m.info_medication.ean"> · EAN {{ m.info_medication.ean }}</span>
            </div>
            <div class="med__marcas">
              <v-chip x-small label color="orange lighten-4" v-if="m.info_medication.requires_formula"><v-icon x-small left color="orange darken-2">mdi-prescription</v-icon>Requiere fórmula</v-chip>
              <v-chip x-small label color="red lighten-4" v-if="m.info_medication.controlled_product"><v-icon x-small left color="red">mdi-account-lock</v-icon>Controlado</v-chip>
              <v-chip x-small label color="blue lighten-5" v-if="m.has_batch"><v-icon x-small left>mdi-barcode</v-icon>Con lote</v-chip>
            </div>
          </div>
          <div class="med__venta">
            <div class="med__precio">{{ precio(m) }}</div>
            <v-chip x-small label :color="agotado(m) ? 'red darken-1' : existencia(m) === null ? 'grey lighten-3' : existencia(m) > 0 ? 'green lighten-4' : 'red lighten-4'"
              :dark="agotado(m)">
              {{ agotado(m) ? "Agotado" : existencia(m) === null ? "Sin dato de existencias" : existencia(m) > 0 ? existencia(m) + " en existencia" : "Sin existencias" }}
            </v-chip>
          </div>
          <div class="med__acciones">
            <v-btn icon small title="Ver la ficha completa" @click="$refs.showInfoMedication.renderItem(m)"><v-icon small>mdi-information-outline</v-icon></v-btn>
            <v-btn small depressed color="success" :disabled="agotado(m)" @click="addItem(m)"><v-icon small left>mdi-plus</v-icon>Agregar</v-btn>
          </div>
        </div>
        <div v-if="visibles.length < total" class="text-center pa-3">
          <v-btn outlined color="primary" small @click="limite += 40">Ver más ({{ total - visibles.length }})</v-btn>
        </div>
      </v-card-text>
      <ShowInfoMedication ref="showInfoMedication" @add:item="addItem" />
    </v-card>
  </v-dialog>
</template>
<script>
import ShowInfoMedication from "./ShowInfoMedication.vue";
import { esAgotado } from "@/plugins/pos/agotados";

export default {
  components: { ShowInfoMedication },
  props: ["priceList"],
  data() {
    return {
      resultados: [],
      texto: "",
      filtros: {},
      masFiltros: false,
      cargando: false,
      limite: 40,
      ingredienteActivo: "",
      espera: null,
    };
  },
  computed: {
    total() {
      return this.resultados.length;
    },
    visibles() {
      return this.resultados.slice(0, this.limite);
    },
    hayFiltros() {
      return !!(this.texto || this.ingredienteActivo || Object.values(this.filtros).some((v) => v));
    },
  },
  watch: {
    // Busca mientras se escribe, con una pequeña espera.
    texto() {
      this.programar();
    },
    filtros: {
      deep: true,
      handler() {
        this.programar();
      },
    },
  },
  async mounted() {
    await this.buscar();
  },
  beforeDestroy() {
    clearTimeout(this.espera);
  },
  methods: {
    programar() {
      clearTimeout(this.espera);
      this.espera = setTimeout(() => this.buscar(), 300);
    },
    limpiar() {
      this.texto = "";
      this.filtros = {};
      this.ingredienteActivo = "";
    },
    // Todo lo que lleva el mismo principio activo: los genéricos y sustitutos del medicamento.
    verGenericos(m) {
      this.texto = "";
      this.filtros = {};
      this.ingredienteActivo = m.info_medication.active_ingredient;
      this.buscar();
    },
    async buscar() {
      this.cargando = true;
      this.limite = 40;
      try {
        const filtros = { ...this.filtros };
        const palabras = [this.texto, this.ingredienteActivo].filter(Boolean).join(" ").trim();
        if (palabras) filtros.key_word = palabras;
        this.resultados = (await this.$db.getAllMedications(filtros)) || [];
      } catch (e) {
        this.resultados = [];
      } finally {
        this.cargando = false;
      }
    },
    agotado(m) {
      return esAgotado(m.id);
    },
    precio(m) {
      const lista = this.priceList && this.priceList.id ? this.priceList.id : null;
      return this.$filters.currency(this.$pos.getSalePrice(m, 0, lista), 0);
    },
    // Lo que dice el inventario de la caja (en la unidad base); null si la caja todavía no lo tiene.
    existencia(m) {
      const stock = this.$db.adapter && this.$db.adapter.db && this.$db.adapter.db.getCollection("stock");
      if (!stock || !m.has_inventory) return null;
      return stock.find({ inv_product_id: m.id }).reduce((t, f) => t + (parseFloat(f.quantity) || 0), 0);
    },
    addItem(item) {
      this.$emit("close", item);
    },
  },
};
</script>
<style>
/* Centrada y con aire arriba y abajo: sin esto la ventana ocupaba casi toda la altura y su encabezado se montaba sobre el de la página. */
.busqueda-med:not(.v-dialog--fullscreen) {
  /* Siempre debajo de la barra de la página (70 px): así su encabezado y el botón de cerrar no se montan con ella. */
  align-self: flex-start;
  max-height: calc(100vh - 120px) !important;
  margin: 90px auto 24px !important;
}

/* Encabezado propio: la barra de Vuetify hereda un alto fijo de 70 px del estilo global y su contenido se salía sobre el buscador. */
.busqueda-med__encabezado {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  height: 56px;
  padding: 0 8px 0 16px;
  color: #fff;
  background: var(--pos-encabezado);
}

.busqueda-med__titulo {
  font-size: 1.2rem;
  font-weight: 500;
}

.busqueda-med__filtros {
  padding: 10px 14px 6px;
}

.busqueda-med__fila {
  display: flex;
  align-items: center;
  margin-top: 4px;
}

.busqueda-med__campos {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 10px;
  padding: 6px 0 4px;
}

.busqueda-med__generico {
  display: flex;
  align-items: center;
  margin-top: 6px;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 0.9rem;
  background: #e0f2f1;
}

.busqueda-med__lista {
  min-height: 240px;
}

.med {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 14px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.med--agotado {
  opacity: 0.6;
}

.med__datos {
  flex: 1 1 auto;
  min-width: 0;
}

.med__nombre {
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.25;
}

.med__detalle {
  margin-top: 2px;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.75);
}

.med__detalle--tenue {
  font-size: 0.78rem;
  color: rgba(0, 0, 0, 0.5);
}

.med__principio {
  font-weight: 600;
  color: #00796b !important;
  text-decoration: underline dotted;
  cursor: pointer;
}

.med__marcas {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}

.med__venta {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  min-width: 130px;
}

.med__precio {
  font-size: 1.15rem;
  font-weight: 800;
  color: #2e7d32;
}

.med__acciones {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 4px;
}

@media (max-width: 700px) {
  .med {
    flex-wrap: wrap;
  }

  .med__venta {
    align-items: flex-start;
    min-width: 0;
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }

  .med__acciones {
    margin-left: auto;
  }
}
</style>
